import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "upload-a-form-template",
  courseId: "forms",
  order: 1,
  title: "Upload a template",
  subtitle: "Bring in a PDF form",
  summary:
    "Turn a department PDF (tow sheet, DUI form, property receipt) into a reusable template. Fillable PDFs have their fields detected automatically.",
  learn: [
    "Upload a PDF and choose personal or agency scope",
    "Let the app auto-detect fillable fields",
    "Know what to do with a flat, scanned PDF",
  ],
  minutes: 3,
  sceneId: "upload-a-form-template",
  tourId: "upload-a-form-template",
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "A template is the PDF plus a map of where each answer goes. Upload the blank form once and every fill after that reuses the same map.",
    },
    {
      type: "steps",
      items: [
        "Click **Forms** in the sidebar, then **Upload Template**.",
        "In \"Upload Form Template\", pick the PDF and give it a Template Name and an optional Description.",
        "Choose Template Scope: **Personal (only you)** or **Agency (shared)**.",
        "Click **Upload with N Fields** (a fillable PDF) or **Upload & Auto-detect Fields** (a flat one). A tray in the corner follows the upload and the AI reading the form.",
        "When the tray shows it is done, open the new template from the list to see its field count and sections. Click **Edit Fields** to add any it missed.",
      ],
    },
    {
      type: "paragraph",
      text: "Agency scope is available to admins, and officers' templates are personal. If the PDF has real form fields (AcroForm), they are read out with their positions and names.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Flat PDFs",
      text: "A scanned or printed-to-PDF form has no fields to detect. Upload it anyway: the dialog says \"No form fields detected\" and the AI reads the form and places the fields for you. You can run **Auto-detect fields** again from the Form Designer, or draw boxes yourself.",
    },
    {
      type: "paragraph",
      text: "Templates are grouped as Department Templates (shared, read-only for officers) and My Templates. **Duplicate** on a department template makes a personal copy you can edit.",
    },
    {
      type: "paragraph",
      text: "Next, \"Design fields\" shows how to name the fields so the AI fills them correctly.",
    },
  ],
  related: ["design-fields-and-sections", "fill-a-form-from-audio"],
};

export default lesson;
